<template>
  <div v-if="showCard" class="mb-6">
    <section aria-labelledby="events-title">
      <div>
        <div class="mt-6 flex justify-end">
          <div class="flex">
            <TButton
              v-if="contact.events.length > notesIndex"
              class="ml-2"
              label="Show All"
              color="white"
              @click="notesIndex = notesIndex + 999999"
            >
            </TButton>
            <TButton
              v-else-if="contact.events.length > 5"
              class="ml-2"
              label="Show Less"
              color="white"
              @click="notesIndex = 5"
            >
            </TButton>
          </div>
        </div>
        <div class="mt-6">
          <ul role="list" class="divide-y divide-gray-200">
            <li v-for="event of contact.events" :key="event.id" class="py-4">
              <div class="flex items-center justify-between">
                <div class="flex space-x-3 items-center">
                  <div>
                    <div class="text-sm">
                      <div class="flex">
                        <div class="font-medium text-gray-900 mr-2">{{ event.event_type }}</div>
                        <svg
                          v-if="event.status == 'active'"
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <svg
                          v-else-if="event.status == 'canceled'"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-red-400"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span class="capitalize font-medium text-gray-500 mr-1.5">
                          {{ event.status }}
                        </span>
                      </div>
                    </div>
                    <div class="mt-1 text-sm text-gray-700">
                      <p>
                        {{ event.name }} - {{ formatDate(event.start_time, 'MMMM dd yyyy, h:mm a') }} to
                        {{ formatDate(event.end_time, 'h:mm a') }}
                      </p>
                    </div>
                    <div class="mt-2 space-x-2 text-sm">
                      <span class="font-medium text-gray-500">
                        {{ new Date(event.end_time) > new Date() ? 'in' : '' }}
                        {{ fromNow(event.end_time) }}
                        {{ new Date(event.end_time) > new Date() ? '' : 'ago' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DateUtility from '../../utilities/dates';

export default {
  props: ['contact'],
  data() {
    return {
      notesIndex: 5,
    };
  },
  computed: {
    showCard() {
      if (!this.contact.events) return false;

      return this.contact.events.length > 0;
    },
  },
  methods: {
    ...DateUtility,
  },
};
</script>
